// extracted by mini-css-extract-plugin
module.exports = {"form":"form-5ab1130a","tip":"tip-a34735c4"};